import router from './routes/routes'
import locales from './locales/locales'

export const MailsModule = {
    name: "mails",
    routes: router,
    locales: locales,
}